"use strict";

exports.__esModule = true;
exports.PlantStateFilterController = PlantStateFilterController;
var _react = _interopRequireWildcard(require("react"));
var _URLFilter = require("../../Core/URLFilter");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _RestAPI = require("../../API/RestAPI");
var _customHooks = require("../../../Utils/customHooks");
var _timeDefinitions = require("../../timeDefinitions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var SET_REFRESH_INTERVAL = "set_refresh_interval";
var SET_SHOULD_REFRESH = "set_should_refresh";
var SET_DEVICES = "set_devices";
var UPDATE_RESET_COUNT = "update_reset_count";
var reducer = function reducer(componentState, action) {
  switch (action.type) {
    case SET_REFRESH_INTERVAL:
      {
        if (typeof action.payload === "number" && action.payload !== componentState.refreshInterval) {
          return Object.assign({}, componentState, {
            refreshInterval: action.payload
          });
        }
        return componentState;
      }
    case SET_SHOULD_REFRESH:
      {
        if (typeof action.payload === "boolean" && action.payload !== componentState.shouldRefresh) {
          return Object.assign({}, componentState, {
            shouldRefresh: action.payload
          });
        }
        return componentState;
      }
    case SET_DEVICES:
      {
        if (typeof action.payload === "object") {
          return Object.assign({}, componentState, {
            devices: action.payload
          });
        }
        return componentState;
      }
    case UPDATE_RESET_COUNT:
      {
        var resetCount = componentState.resetCount < 100 ? componentState.resetCount + 1 : 0;
        return Object.assign({}, componentState, {
          resetCount: resetCount
        });
      }
    default:
      {
        return componentState;
      }
  }
};
var initialComponentState = function initialComponentState(devices) {
  return {
    devices: devices,
    refreshInterval: (0, _timeDefinitions.getMinutesMillis)(15),
    shouldRefresh: false,
    resetCount: 0
  };
};
function PlantStateFilterController(props) {
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var _React$useContext = _react["default"].useContext(_URLFilter.URLFilterContext),
    filters = _React$useContext.filters;
  var api = _react["default"].useContext(_RestAPI.RestAPIContext);
  var states = filters.states;
  var _React$useReducer = _react["default"].useReducer(reducer, initialComponentState(devices)),
    componentState = _React$useReducer[0],
    dispatcher = _React$useReducer[1];
  var shouldRefresh = componentState.shouldRefresh,
    refreshInterval = componentState.refreshInterval,
    resetCount = componentState.resetCount,
    filteredDevices = componentState.devices;
  var callbackFunction = _react["default"].useCallback(function () {
    fetchDevicesBasedOnFilter({
      states: states,
      api: api,
      devices: devices,
      dispatcher: dispatcher
    });
  }, [states, devices]);
  (0, _customHooks.useInterval)({
    interval: refreshInterval,
    callbackFunction: callbackFunction,
    resetCount: resetCount
  });
  var children = props.children;

  // filter devices based on state
  (0, _react.useEffect)(function () {
    dispatcher({
      type: UPDATE_RESET_COUNT
    });
    var abortController = new window.AbortController();
    var signal = abortController.signal;
    fetchDevicesBasedOnFilter({
      states: states,
      api: api,
      devices: devices,
      dispatcher: dispatcher,
      signal: signal
    });
    return function () {
      if (signal && abortController.abort) {
        abortController.abort();
      }
    };
  }, [states, devices]);

  // filter devices based on state
  (0, _react.useEffect)(function () {
    if (shouldRefresh) {
      dispatcher({
        type: UPDATE_RESET_COUNT
      });
      var abortController = new window.AbortController();
      var signal = abortController.signal;
      fetchDevicesBasedOnFilter({
        states: states,
        api: api,
        devices: devices,
        dispatcher: dispatcher,
        signal: signal
      }).then(function () {
        dispatcher({
          type: SET_SHOULD_REFRESH,
          payload: false
        });
      });
      return function () {
        if (signal && abortController.abort) {
          abortController.abort();
        }
      };
    }
  }, [shouldRefresh]);
  var refreshFunctions = {
    setRefreshInterval: function setRefreshInterval(refreshInterval) {
      dispatcher({
        type: SET_REFRESH_INTERVAL,
        payload: refreshInterval
      });
    },
    onRefresh: function onRefresh() {
      dispatcher({
        type: SET_SHOULD_REFRESH,
        payload: true
      });
    }
  };
  return children(Object.assign({
    devices: filteredDevices,
    sourceDevices: devices,
    shouldRefresh: shouldRefresh,
    refreshInterval: refreshInterval
  }, refreshFunctions));
}
function fetchDevicesBasedOnFilter(_x) {
  return _fetchDevicesBasedOnFilter.apply(this, arguments);
}
function _fetchDevicesBasedOnFilter() {
  _fetchDevicesBasedOnFilter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var states, devices, api, dispatcher, signal, url, deviceUuids, body, filteredDeviceUuids, filteredDevices, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          states = _ref.states, devices = _ref.devices, api = _ref.api, dispatcher = _ref.dispatcher, signal = _ref.signal;
          url = "/api/v3/timeseries/timeline/latest";
          deviceUuids = devices.map(function (device) {
            return device.uuid;
          });
          if (states.length) {
            _context.n = 1;
            break;
          }
          dispatcher({
            type: SET_DEVICES,
            payload: devices
          });
          return _context.a(2);
        case 1:
          body = {
            type: ["time-series-classification"],
            entity: {
              device: deviceUuids
            },
            dimensions: {
              state: states
            },
            aggregateBy: {
              entity: ["device"]
            }
          };
          _context.p = 2;
          _context.n = 3;
          return api.post(url, body, false, signal);
        case 3:
          filteredDeviceUuids = _context.v;
          filteredDevices = devices.filter(function (device) {
            return filteredDeviceUuids.includes(device.uuid);
          });
          dispatcher({
            type: SET_DEVICES,
            payload: filteredDevices
          });
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          // log
          console.error(_t);
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[2, 4]]);
  }));
  return _fetchDevicesBasedOnFilter.apply(this, arguments);
}